import { Component, inject, input, output } from '@angular/core';
import { MatButton, MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { FloatingButtonTypes, GroupItem, ItemHelp } from '@vectronic/util';

@Component({
  selector: 'vectronic-floating-buttons',
  templateUrl: './floating-buttons.component.html',
  styleUrls: ['./floating-buttons.component.scss'],
  imports: [MatButton, MatIcon, MatFabButton, MatMenuTrigger, MatMenu, MatMenuItem, MatTooltip],
})
export class FloatingButtonsComponent {
  numberOfSelectedItems = input<number>();
  groupType = input<GroupItem>();
  visibleButtons = input<FloatingButtonTypes[]>([]);
  isOwnerOfAllSelectedItems = input<boolean>();
  showSelectionButtons = input(true);

  createGroup = output();
  downloadCSV = output();
  removeItems = output();
  createItem = output();
  openFilters = output();
  openSelection = output();
  unsubscribeFromItems = output();
  floatingButtonsType = FloatingButtonTypes;

  private router = inject(Router);

  areMoreThanOneSelected() {
    return this.numberOfSelectedItems() > 1;
  }

  isAtLeastOneSelected() {
    return this.numberOfSelectedItems() == null ? true : this.numberOfSelectedItems() > 0;
  }

  navigateToGroups() {
    this.router.navigate([ItemHelp.toRoute(this.groupType())]);
  }
}
